import { Heading } from '../Heading';
import { InsightsLabelGroup } from '../InsightsLabelGroup/InsightsLabelGroup';
import { Paragraph } from '../Paragraph';

export type InsightsTitleProps = {
  title: string;
  date: Date | null;
  location: string;
  newInsight?: boolean;
  categories: string[];
  marketSegment: string | null;
  sustainable?: boolean;
};

export const InsightsTitle: React.FC<InsightsTitleProps> = ({
  title,
  date,
  location,
  newInsight = false,
  categories,
  marketSegment,
  sustainable,
}) => {
  const dateString = date?.toLocaleDateString();

  return (
    <>
      <div>
        <Heading level="h3" margin="4px" text={title} />
        <div className="flex flex-wrap">
          {date && (
            <Paragraph variant="medium" color="dark" lineHeight={4}>
              {dateString}&nbsp;|&nbsp;
            </Paragraph>
          )}
          <Paragraph variant="medium" color="dark" lineHeight={4}>
            {location}
          </Paragraph>
          {marketSegment && (
            <Paragraph variant="medium" color="dark" lineHeight={4}>
              &nbsp;|&nbsp;{marketSegment}
            </Paragraph>
          )}
        </div>
      </div>
      <InsightsLabelGroup
        newInsight={newInsight}
        categories={categories}
        sustainable={sustainable}
      />
    </>
  );
};
